import React from 'react';
import { Gamepad2, Lightbulb } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

const pick = (lang, ar, en) => (lang === 'en' && en ? en : ar);
const TONE = { green: 'bg-emerald-100 text-emerald-700', red: 'bg-rose-100 text-rose-700', blue: 'bg-blue-600 text-white', amber: 'bg-amber-100 text-amber-700', gray: 'bg-slate-100 text-slate-600' };

export const InstructionsCard = ({ sim, metrics }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const steps = (pick(lang, sim.instructionsAr, sim.instructionsEn) || '').split('\n').map(s => s.trim()).filter(Boolean);
  const goal = pick(lang, sim.goalAr, sim.goalEn);
  if (!steps.length && !goal && !metrics.length) return null;
  return (
    <section data-testid="sim-instructions-card" className="rounded-3xl bg-white border border-slate-200 p-4 sm:p-5 space-y-4 shadow-sm">
      {steps.length > 0 && (
        <div>
          <h2 className="flex items-center gap-2 text-slate-900 font-black text-lg mb-3"><Gamepad2 className="w-5 h-5 text-blue-600" />{L('تعليمات المحاكاة', 'Instructions')}</h2>
          <ol className="space-y-2">
            {steps.map((s, i) => (
              <li key={i} data-testid={`sim-instruction-${i}`} className="flex items-start gap-2.5 text-sm text-slate-700 leading-relaxed">
                <span className="w-6 h-6 shrink-0 rounded-full bg-blue-600 text-white text-xs font-black flex items-center justify-center">{i + 1}</span>{s}
              </li>
            ))}
          </ol>
        </div>
      )}
      {goal && (
        <div data-testid="sim-goal" className="rounded-2xl bg-blue-50 border border-blue-100 p-3.5">
          <p className="flex items-center gap-2 text-blue-700 font-black text-sm mb-1"><Lightbulb className="w-4 h-4" />{L('هدف المحاكاة', 'Goal')}</p>
          <p className="text-sm text-slate-700 leading-relaxed">{goal}</p>
        </div>
      )}
      {metrics.length > 0 && (
        <div data-testid="sim-metrics" className="grid grid-cols-2 gap-2.5">
          {metrics.map((m, i) => (
            <div key={i} data-testid={`sim-metric-${i}`} className="rounded-2xl border border-slate-200 p-3">
              <p className="text-xs text-slate-500 mb-1.5">{m.label}</p>
              <span className={`inline-flex px-3 py-1 rounded-full text-sm font-black ${TONE[m.tone]}`}>{m.value}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
